import React from 'react'
import Video from '../Video/Video'

import './Recommended.css'




const Recommended = () => {
    return (
        <div className='recommended'>

            <h2>Recommended</h2>
            <div className="recommended__videos">
                <Video
                    title='Become a Web Developer in 10 minutes | 2022/2023'
                    views='2.3M Views'
                    timestamp='3 days ago'
                    channelImage='https://yt3.ggpht.com/yti/APfAmoGrWUVbzJfXS2IjcFOcukolO4zjHIzJoDxc8Msv=s108-c-k-c0x00ffffff-no-rj'
                    channel='Passionate'
                    image='https://images.unsplash.com/photo-1541877944-ac82a091518a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80'




                />




                <Video
                    title='Become a Web Developer in 10 minutes | 2022/2023'
                    views='2.3M Views'
                    timestamp='3 days ago'
                    channelImage='https://yt3.ggpht.com/yti/APfAmoGrWUVbzJfXS2IjcFOcukolO4zjHIzJoDxc8Msv=s108-c-k-c0x00ffffff-no-rj'
                    channel='Passionate'
                    image='https://images.unsplash.com/photo-1541877944-ac82a091518a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80'




                />



                <Video
                    title='Become a Web Developer in 10 minutes | 2022/2023'
                    views='2.3M Views'
                    timestamp='3 days ago'
                    channelImage='https://yt3.ggpht.com/yti/APfAmoGrWUVbzJfXS2IjcFOcukolO4zjHIzJoDxc8Msv=s108-c-k-c0x00ffffff-no-rj'
                    channel='Passionate'
                    image='https://images.unsplash.com/photo-1541877944-ac82a091518a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80'




                />




                <Video
                    title='Become a Web Developer in 10 minutes | 2022/2023'
                    views='2.3M Views'
                    timestamp='3 days ago'
                    channelImage='https://yt3.ggpht.com/yti/APfAmoGrWUVbzJfXS2IjcFOcukolO4zjHIzJoDxc8Msv=s108-c-k-c0x00ffffff-no-rj'
                    channel='Passionate'
                    image='https://images.unsplash.com/photo-1541877944-ac82a091518a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80'




                />




                <Video
                    title='Become a Web Developer in 10 minutes | 2022/2023'
                    views='2.3M Views'
                    timestamp='3 days ago'
                    channelImage='https://yt3.ggpht.com/yti/APfAmoGrWUVbzJfXS2IjcFOcukolO4zjHIzJoDxc8Msv=s108-c-k-c0x00ffffff-no-rj'
                    channel='Passionate'
                    image='https://images.unsplash.com/photo-1541877944-ac82a091518a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80'




                />




                <Video
                    title='Become a Web Developer in 10 minutes | 2022/2023'
                    views='2.3M Views'
                    timestamp='3 days ago'
                    channelImage='https://yt3.ggpht.com/yti/APfAmoGrWUVbzJfXS2IjcFOcukolO4zjHIzJoDxc8Msv=s108-c-k-c0x00ffffff-no-rj'
                    channel='Passionate'
                    image='https://images.unsplash.com/photo-1541877944-ac82a091518a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80'




                />

            </div>

        </div>
    )
}

export default Recommended